import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants/keys";

class PaymentsStore {
    static recentPayment = new CachedItem(Key.madePayment, false, 60000);

    static transactionId = new CachedItem("transaction.id", false, 60000);
}

export default PaymentsStore;
